import { gql } from "@apollo/client";

export const MUTATION_CREATE_PROJECT_REPORT = gql`
  mutation CreateProjectReport($feature_type_id: Int = 2) {
    create_custom_report(feature_type_id: $feature_type_id) {
      id
      message
    }
  }
`;

export const MUTATION_DELETE_PROJECT_REPORT = gql`
  mutation DeleteCustomReportMutation($project_report_id: String!) {
    delete_custom_report(project_report_id: $project_report_id) {
      message
    }
  }
`;

export const MUTATION_UPDATE_PROJECT_REPORT = gql`
  mutation UpdateCustomReportMutation(
    $project_report_id: String!
    $data: json!
  ) {
    update_custom_report(data: $data, project_report_id: $project_report_id) {
      message
    }
  }
`;
